import * as State from 'components/desktop/Ingredient/IngredientProducts/OrderGuideMapping/State';
import { useHandler } from 'hooks/useHandler';

export default function useState() {
	const [state, rf] = useHandler<State.Type>(State.create());
	return {
		state,
		handlers: {
			closeProductSearch: rf.createNoArgReducer(State.closeProductSearch),
			initialize: rf.createReducerAsync(State.initialize),
			openProductSearch: rf.createReducer(State.openProductSearch),
			removeProduct: rf.createReducerAsync(State.removeProduct),
			searchProducts: rf.createReducerAsync(State.searchProducts),
			addProduct: rf.createReducerAsync(State.addProduct),
			togglePriority: rf.createReducer(State.togglePriority),
			changePriorityOfProduct: rf.createReducerAsync(State.changePriorityOfProduct),
		},
	};
}

export type Handlers = ReturnType<typeof useState>['handlers'];
